'use strict';

import { fieldDefinitionService } from './fieldDefinitionService.fn';

fieldDefinitionService.$inject = ['$filter', 'dateUtils'];
angular.module('kerp-forms.forms').factory('fieldDefinitionService', fieldDefinitionService);
